import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import MinHeight from "%/dynamic-component-editor/options/min-height";

export default class LayoutWidthHeightOptions extends BaseOptionsBundle {
  optionTitle = "Layout";
  static optionClassName = "i-dynamic-layout-width-height";
  inspectorToolGroup = "widthHeight";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.WIDTH_HEIGHT_TOOL_SET,
  };
  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new LayoutWidth(undefined, hideFromInspector["layout-width"] ?? false),
      new LayoutHeight(undefined, hideFromInspector["layout-height"] ?? false),
      new MaxWidth(undefined, hideFromInspector["max-width"] ?? false),
      new MaxHeight(undefined, hideFromInspector["max-height"] ?? false),
      new MinWidth(undefined, hideFromInspector["min-width"] ?? false),
      new MinHeight(undefined, hideFromInspector["min-height"] ?? false),
    ]);
  }
}
